var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3399_7790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.91211 1.26563L2.70898 1.875H1.25C0.560547 1.875 0 2.43555 0 3.125V8.125C0 8.81445 0.560547 9.375 1.25 9.375H8.75C9.43945 9.375 10 8.81445 10 8.125V3.125C10 2.43555 9.43945 1.875 8.75 1.875H7.29102L7.08789 1.26563C6.96094 0.882813 6.60352 0.625 6.19922 0.625H3.80078C3.39648 0.625 3.03906 0.882813 2.91211 1.26563ZM5 3.75C5.49728 3.75 5.97419 3.94754 6.32583 4.29917C6.67746 4.65081 6.875 5.12772 6.875 5.625C6.875 6.12228 6.67746 6.59919 6.32583 6.95083C5.97419 7.30246 5.49728 7.5 5 7.5C4.50272 7.5 4.02581 7.30246 3.67417 6.95083C3.32254 6.59919 3.125 6.12228 3.125 5.625C3.125 5.12772 3.32254 4.65081 3.67417 4.29917C4.02581 3.94754 4.50272 3.75 5 3.75Z",
    fill: "#4F46E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3399_7790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera-icon.af3de14588932d7ba08f87c032894649.svg";
export { ForwardRef as ReactComponent };